import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useFetchAccountParams } from 'newhooks/account/useFetchAccountParams';
import { getPartnerConfigs } from 'store/selectors/socket';
import { getUser } from 'store/selectors/user-data';

export const useBonusSectionsToExclude = (): string[] | null => {
  const { accountParams } = useFetchAccountParams();
  const user = useSelector(getUser);
  const partnerConfigs = useSelector(getPartnerConfigs);

  return useMemo(() => {
    if (accountParams && !user.pending) {
      const _bonusSectionsToExclude = new Set([
        'accounts:bonuses:refer-friend',
        'accounts:bonuses:management'
      ]);

      const referAFriendAvailable =
        +accountParams.referAFriend === 1 &&
        ((partnerConfigs && !partnerConfigs.reffrend_client_cats) ||
          !!partnerConfigs?.reffrend_client_cats?.includes(
            user.sportsbook_profile_id
          ));

      const bonusManagementAvailable = +accountParams.bonusManagement === 1;
      const bonusManagementForOnlyVerified =
        +accountParams.bonusManagementOnlyVerified === 1;

      if (referAFriendAvailable) {
        _bonusSectionsToExclude.delete('accounts:bonuses:refer-friend');
      }

      if (
        user.is_bonus_allowed !== false &&
        bonusManagementAvailable &&
        (!bonusManagementForOnlyVerified ||
          (bonusManagementForOnlyVerified && user.is_verified))
      ) {
        _bonusSectionsToExclude.delete('accounts:bonuses:management');
      }

      if (_bonusSectionsToExclude.size === 2) {
        _bonusSectionsToExclude.add('accounts:bonuses:bonus');
      }

      return Array.from(_bonusSectionsToExclude);
    }

    return null;
  }, [accountParams, user, partnerConfigs]);
};
